import { render, staticRenderFns } from "./edit-details.vue?vue&type=template&id=b8d55dc4"
import script from "./edit-details.vue?vue&type=script&lang=js"
export * from "./edit-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports